import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PrimerGooglePayOptions from './_paymentMethodOptions/googlePayOptions.mdx';
import PrimerKlarnaOptions from './_paymentMethodOptions/klarnaOptions.mdx';
import PrimerStripeOptions from './_paymentMethodOptions/stripeOptions.mdx';
import PrimerThreeDsOptions from './threeDsOptions.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='redirectScheme' subtitle='String?' mdxType="Item">
	Sets the deeplink schema used when redirecting back from 3rd party applications to your application.
    </Item>
    <Item title='threeDsOptions' subtitle='PrimerThreeDsOptions' mdxType="Item">
	Sets the 3DS options in the SDK.
	<Group open summary='Properties' mdxType="Group">
		<PrimerThreeDsOptions mdxType="PrimerThreeDsOptions" />
	</Group>
    </Item>
    <Item title='googlePayOptions' subtitle='PrimerGooglePayOptions' mdxType="Item">
	⚠️ Required when using Google Pay in your integration.
	<Group open summary='Properties' mdxType="Group">
		<PrimerGooglePayOptions mdxType="PrimerGooglePayOptions" />
	</Group>
    </Item>
    <Item title='klarnaOptions' subtitle='PrimerKlarnaOptions' mdxType="Item">
	⚠️ Required when using Klarna in your integration.
	<Group open summary='Properties' mdxType="Group">
		<PrimerKlarnaOptions mdxType="PrimerKlarnaOptions" />
	</Group>
    </Item>
    <Item title='stripeOptions' subtitle='PrimerStripeOptions' mdxType="Item">
	⚠️ Required when using Stripe ACH in your integration.
	<Group open summary='Properties' mdxType="Group">
		<PrimerStripeOptions mdxType="PrimerStripeOptions" />
	</Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      